import React, { useState, useRef, useContext } from "react";
import '../../css/email.css';
import {sendEmail} from '../../utilities/emailFunctions';
import { useSelector } from 'react-redux';
import { setLoadingGif } from "../../features/loadingSlice";
import { useDispatch } from "react-redux";
import WysiwygEditor from "./wysiwyg"
import { AgentContext } from "../../context/AgentContext";

function Email({ email, setIsEmailOpen }) {
    const dispatch = useDispatch()
    const agentInfo=useSelector((state) => state.agent.userData);
    const [editedContent, setEditedContent] = useState('');
    const [subject, setSubject] = useState('');
    const [recipient, setRecipient] = useState(email ?? '');
    const [value, setValue] = useState(editedContent ?? '');
    const [showEmailStatusModal, setShowEmailStatusModal] = useState(false)
    const [disabled, setDisabled] = useState(false)

    const handleSubject=(subject)=>{
        setSubject(subject)
    }
    const handleRecipient=(recipient)=>{
        setRecipient(recipient);
    }

    const resetFields = () => {
        setEditedContent('')
        setSubject('')
        setRecipient(email || recipient)
        setValue('')
    }

    const sendEmailStatusMessageRef = useRef('Sending email.')
    const emailModalRef = useRef(null)
    const sendEmailButtonRef = useRef(null)

    const handleEmailRequest = async () => {
        setDisabled(true)
        dispatch(setLoadingGif(true))

        let result

        try {
            result = await sendEmail(recipient, subject, value, agentInfo.agentId, agentInfo.firstName, agentInfo.lastName, setIsEmailOpen)
        } catch (error) {
            result = false
        }

        dispatch(setLoadingGif(false))

        if(!result){
            sendEmailStatusMessageRef.current = `Could not send your email to ${recipient}. Please try again later.`
            setShowEmailStatusModal(true)
            return
        }

        sendEmailStatusMessageRef.current = `Your email to ${recipient} has been sent!`
        setShowEmailStatusModal(true)
        resetFields()
    }

    const closeEmailModal = () => {
        setShowEmailStatusModal(false)
        setDisabled(false)
        sendEmailStatusMessageRef.current = 'Sending email.'
    }

    const {isB2B} = useContext(AgentContext)

    return (
        <div style={{color:'black',height: 'calc(100% - 95px)',overflow: 'auto'}}>
            <div className="inputFieldWrapper" style={{height: "initial !important"}}>
                <div className="qualifierFieldTitle emailEnhance">To: </div>
                <input
                    type="text"
                    className="qualifierFieldInput"
                    style={{ width: '50%',maxWidth: 'unset'}}
                    value={recipient}
                    onChange={(e)=>handleRecipient(e.target.value)}
                    disabled={disabled}
                />
            </div>
            <div className="inputFieldWrapper" style={{height: "initial !important"}}>
                <div className="qualifierFieldTitle emailEnhance">Subject: </div>
                <input
                    type="text"
                    className="qualifierFieldInput"
                    style={{ width: '50%',maxWidth: 'unset'}}
                    value={subject}
                    onChange={(e)=>handleSubject(e.target.value)}
                    disabled={disabled}
                />
            </div>
            {showEmailStatusModal && (
                <div ref={emailModalRef} style={{ maxWidth: '625px', position: 'absolute', background: 'white', zIndex: '3', margin: '0px auto', padding: '16px 10px', border: '1px solid var(--quility-input-border-color)', borderRadius: '5px', top: '50%', left: '3%'}}>
                    <div style={{ width: '100%', height: '100%', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '16px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                        <div style={{ width: '100%', alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'center', gap: 16, display: 'inline-flex' }}>
                            <div style={{ color: 'black', fontSize: 26, fontFamily: 'Montserrat', fontWeight: '700', letterSpacing: 0.10, wordWrap: 'break-word' }}>Email Confirmation</div>
                        </div>
                        <div style={{ alignSelf: 'stretch', color: '#707070', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', letterSpacing: 0.07, wordWrap: 'break-word' }}>
                            {sendEmailStatusMessageRef.current}
                        </div>
                        <div style={{ width: '100%', alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex' }}>
                            <div className="buttonWrapper" style={{margin:"20px 0px"}}>
                                <div className={`accentButton ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`} onClick={()=> closeEmailModal()}>Close</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="inputFieldWrapper" style={{height: 'calc(85% - 130px)'}}>
                <div className="qualifierFieldTitle emailEnhance">
                Content:
                </div>
                <WysiwygEditor setValue={setValue} value={value} />
                <div className="buttonWrapper" style={{margin:"0px 0px"}}>
                    <div ref={sendEmailButtonRef} className={`accentButton ${disabled ? 'solidQuilityInactiveButton' : `${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`}`} onClick={()=> disabled ? null : handleEmailRequest()}>Send Email</div>
                </div>
            </div>
        </div>
    );
}

export default Email;